import get from 'lodash/get';
import omit from 'lodash/omit';
import {PropsWithChildren} from 'react';

import FooterBar from 'src/Components/Common/FooterBar/FooterBar';
import HeaderBar from 'src/Components/Common/HeaderBar/HeaderBar';
import {ILayout} from 'src/Components/Common/withLayout';

const Layout = (props: PropsWithChildren<ILayout>) => (
	<>
		<HeaderBar {...omit(props, 'children')} />
		{props.children}
		<FooterBar addMap={get(props, 'addMap', true)} />
	</>
);

export default Layout;
